import { cn } from "@/lib/utils"

export interface TestimonialAuthor {
    name: string
    handle: string
    avatar?: string
}

export interface TestimonialCardProps {
    author: TestimonialAuthor
    text: string
    className?: string
}

export function TestimonialCard({
    author,
    text,
    className
}: TestimonialCardProps) {
    const CardContent = (
        <div className={cn(
            "relative flex h-full w-[350px] max-w-full flex-col justify-between overflow-hidden rounded-xl border bg-background p-6 shadow-sm transition-all hover:bg-muted/50 hover:shadow-md",
            className
        )}>
            <div className="flex flex-col gap-4">
                <h3 className="text-base font-semibold text-foreground">
                    {author.name}
                </h3>
                <p className="text-sm leading-relaxed text-muted-foreground">
                    {text}
                </p>
            </div>

            <div className="mt-6 border-t border-slate-200 pt-4">
                <span className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
                    {author.handle}
                </span>
            </div>
        </div>
    )

    return CardContent
}
